module.exports = __webpack_public_path__ + "static/media/logo.49174c73.svg";